// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"CmsTellja_icomoon-font__2wmng","Tellja_Container":"CmsTellja_Tellja_Container__21W8w"};